import React from "react";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import ContactForm from "../components/Contact/ContactForm";

export default function Contact() {
  return (
    <InnerPageLayout>
      <BreadCrumb pageTitle="Contact" items={[{ label: "Contact", path: "/contact" }]} />
      <ContactForm />
      {/* <CtaOne /> */}
    </InnerPageLayout>
  );
}
